import React, { useEffect, useState } from "react";
import * as _ from "lodash";

import { getRouteConfigs } from "../../../../helpers/backend_helper";

const useConfiguration = () => {
  const [horarioVelada, setHorarioVelada] = useState("");
  const [isLoadingConfiguration, setIsLoadingConfiguration] = useState(true);

  const fetchVeladaConfig = () => {
    getRouteConfigs()
      .then((response) => {
        const horarioVeladaConfig = _.find(response, { configuration_id: 25 });

        if (horarioVeladaConfig) {
          setHorarioVelada(horarioVeladaConfig.value);
        }
      })
      .finally(() => {
        setIsLoadingConfiguration(false);
      });
  };

  useEffect(fetchVeladaConfig, []);

  return {
    horarioVelada,
    isLoadingConfiguration,
  };
};

export default useConfiguration;
